import axiosClient, { app_uri } from "../../../utils/axiosFactory";
import { ChatClient } from "../../repsaApi";

const client = new ChatClient(app_uri, axiosClient());

export default client;
